import * as React from 'react';
import { MessageIconSvg } from '../SvgImports';

const EmailIcon = () => {
    return (
        <img className="emailIcon" src={MessageIconSvg} alt="Email" />
    );
};

export default EmailIcon;